export enum UserRole {
    GROUP = "GROUP",
    USER = "USER",
    UNKNOWN = "UNKNOWN"
}